// localStorage is NOT always available.
//
// Safari sets window.localStorage to null outright when the visitor blocks
// cookies, and both Safari and Chrome throw on access in some private/embedded
// contexts. Any unguarded localStorage.getItem() therefore takes the WHOLE app
// down at mount with "null is not an object" -- a blank white page, not a
// degraded one.
//
// Family members are not going to debug their browser settings. Read and write
// through these helpers so a blocked-cookies visitor still gets a working site,
// just without remembered preferences.

function backing() {
  try {
    const store = window.localStorage;
    if (!store) return null;
    // Some browsers expose the object but throw on use; prove it works.
    const probe = "__probe__";
    store.setItem(probe, "1");
    store.removeItem(probe);
    return store;
  } catch {
    return null;
  }
}

export function getItem(key, fallback = null) {
  const store = backing();
  if (!store) return fallback;
  try {
    const value = store.getItem(key);
    return value === null ? fallback : value;
  } catch {
    return fallback;
  }
}

export function setItem(key, value) {
  const store = backing();
  if (!store) return false;
  try {
    store.setItem(key, value);
    return true;
  } catch {
    // Quota exceeded, or storage disabled mid-session. Preferences are a
    // convenience -- never let one break the page.
    return false;
  }
}

// No caller today. Kept deliberately: the whole point of this module is that no
// file touches window.localStorage directly, and leaving a gap here is an
// invitation to write the unguarded call that caused the blank page.
export function removeItem(key) {
  const store = backing();
  if (!store) return false;
  try {
    store.removeItem(key);
    return true;
  } catch {
    return false;
  }
}
